import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=2be70d3b&scoped=true"
import script from "./Fail.vue?vue&type=script&lang=js"
export * from "./Fail.vue?vue&type=script&lang=js"
import style0 from "./Fail.vue?vue&type=style&index=0&id=2be70d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be70d3b",
  null
  
)

export default component.exports